module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-row', {
    staticStyle: {
      "min-height": "80px"
    },
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [(_vm.campaignList.length) ? _c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaignList,
      "label": "Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "searchText"
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [(item === Object(item)) ? _c('div', {
          staticClass: "campaign-payment-selection"
        }, [_c('span', {
          staticClass: "campaign-payment-selection__name"
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.ioNumber) ? _c('span', {
          staticClass: "campaign-payment-selection__io"
        }, [_vm._v(_vm._s(item.ioNumber))]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('CampaignListPaymentStatus', {
          attrs: {
            "item": item
          }
        })]
      }
    }], null, false, 1131324621),
    model: {
      value: (_vm.campaignID),
      callback: function($$v) {
        _vm.campaignID = $$v
      },
      expression: "campaignID"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "height": "56px"
    },
    attrs: {
      "disabled": !_vm.campaignID,
      "small": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.getPairedInfluencers(_vm.campaignID, true)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "small": ""
    }
  }, [_vm._v("mdi-cached")]), _vm._v(" Refresh\n      ")], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [(_vm.campaignCOEB && _vm.campaignCOEB.campaignId) ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "#CFD8DC"
    }
  }, [_c('v-card-subtitle', {
    staticClass: "title pb-0"
  }, [_vm._v("\n          Campaign Name: " + _vm._s(_vm.campaignCOEB.campaignName || 'N/A') + "\n          "), (_vm.campaignCOEB.lockedCOGS) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('v-icon', _vm._g({
    attrs: {
      "small": "",
      "left": ""
    }
  }, _vm.on), [_vm._v("mdi-lock")]), _vm._v("Locked COGS")], 1)]) : _vm._e()], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("\n          Client Name: " + _vm._s(_vm.campaignCOEB.clientName || 'N/A') + "\n        ")]), _vm._v(" "), _c('v-card-subtitle', {
    staticClass: "subtitle-1 pt-2"
  }, [_vm._v("\n          IO Number: " + _vm._s(_vm.campaignCOEB.ioNumbers || 'N/A') + "\n        ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mb-2 flex-row-reverse",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.briefConfirmationSearch),
      callback: function($$v) {
        _vm.briefConfirmationSearch = $$v
      },
      expression: "briefConfirmationSearch"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.pairedHeaders,
      "items": _vm.pairedInfluencers,
      "items-per-page": -1,
      "search": _vm.briefConfirmationSearch,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', [(props.items && props.items.length === 0) ? _c('tr', [_c('td', [_vm._v("No Data")])]) : _vm._e(), _vm._v(" "), _vm._l((props.items), function(item) {
          return _c('tr', {
            key: item.influencer_details.instagramHandle
          }, [_c('td', [_c('div', {
            staticClass: "payment-status-handle"
          }, [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.influencer_details.platform === 'tiktok',
              "isInstagram": !item.influencer_details.platform || item.influencer_details.platform === 'instagram',
              "isFacebook": item.influencer_details.platform === 'facebook',
              "isLinkedIn": item.influencer_details.platform === 'linkedin',
              "isTwitter": item.influencer_details.platform === 'twitter',
              "isYoutube": item.influencer_details.platform === 'youtube',
              "isXiaohongshu": item.influencer_details.platform === 'xiaohongshu',
              "isOthers": item.influencer_details.platform === 'others',
              "tiktokHandle": item.influencer_details.instagramHandle,
              "instagramHandle": item.influencer_details.instagramHandle,
              "facebookHandle": _vm.getPlatformHandle(item.influencer_details, 'facebook'),
              "linkedinHandle": item.influencer_details.linkedinHandle || item.influencer_details.userHandle || item.influencer_details.instagramHandle,
              "twitterHandle": _vm.getPlatformHandle(item.influencer_details, 'twitter'),
              "youtubeHandle": item.influencer_details.instagramHandle,
              "youtubeURL": item.influencer_details.url,
              "xiaohongshuHandle": item.influencer_details.xhsID,
              "xiaohongshuFullName": item.influencer_details.fullName,
              "otherHandle": item.influencer_details.instagramHandle
            }
          }), _vm._v(" "), (item.influencer_details && item.influencer_details.influencerID) ? _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "ml-1",
                  attrs: {
                    "color": "green",
                    "small": ""
                  }
                }, on), [_vm._v("done")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('v-icon', _vm._g({
                  staticClass: "ml-1",
                  attrs: {
                    "color": "red",
                    "small": ""
                  }
                }, on), [_vm._v("cancel")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Not registered in IMS")])])], 1), _vm._v(" "), (item.multipleInfs && item.multipleInfs.length > 1) ? _c('v-menu', {
            attrs: {
              "bottom": "",
              "origin": "center center",
              "transition": "scale-transition"
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticStyle: {
                    "min-width": "0",
                    "padding": "0",
                    "margin-left": "-9px",
                    "margin-top": "-3px"
                  },
                  attrs: {
                    "dark": "",
                    "text": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-tooltip', {
                  attrs: {
                    "bottom": ""
                  },
                  scopedSlots: _vm._u([{
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on;

                      return [_c('v-icon', _vm._g({
                        staticClass: "ml-2",
                        attrs: {
                          "color": "secondary",
                          "small": ""
                        }
                      }, on), [_vm._v("mdi-chevron-down-circle")])]
                    }
                  }], null, true)
                }, [_vm._v(" "), _c('span', [_vm._v("Multiple Accounts detected")])])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('v-list', _vm._l((item.multipleInfs), function(obj, i) {
            return _c('v-list-item', {
              key: i
            }, [_c('v-list-item-title', [(obj.xhs) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/xhs-black.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.facebook) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.linkedin) ? _c('a', [_c('v-icon', {
              attrs: {
                "color": "#0A66C2",
                "small": ""
              }
            }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : (obj.twitter) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/x-logo.svg",
                "width": "15px",
                "alt": "",
                "aria-hidden": "true"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.tiktok) ? _c('a', [_c('img', {
              attrs: {
                "src": "/static/img/tiktok-32.png",
                "width": "20px"
              }
            }), _vm._v(" @" + _vm._s(obj.handle))]) : (obj.youtube) ? _c('a', [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(obj.handle))], 1) : _c('a', [_c('v-icon', {
              attrs: {
                "color": "#000000",
                "small": ""
              }
            }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(obj.handle))], 1)])], 1)
          }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDeliverableDetails(item.deliverablesDisplay)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDeliverableCounts(item.producedDeliverables)))]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(!item.GSTIncluded) ? _c('span', [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt && !Number.isNaN(Number(item.sgdAmt)) ? item.sgdAmt : ""))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (item.GSTIncluded) ? _c('span', {
            attrs: {
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": _vm.displayGSTText(item)
            }
          }, [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({}, on), [_vm._v("\n                        " + _vm._s(_vm.utilsFunc.currencySym(item.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)) + "\n                      ")])]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.currency) + " " + _vm._s(_vm._f("thousandSeprator")(item.payoutAmount)))]), _c('br'), _vm._v(" "), (item.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(item.sgdAmt && !Number.isNaN(Number(item.sgdAmt)) ? item.sgdAmt : ""))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (item.GSTIncluded) ? _c('v-icon', {
            attrs: {
              "small": "",
              "color": "secondary",
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              "title": "GST Included"
            }
          }, [_vm._v("mdi-alert-circle-outline")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(_vm.formatSubmissionDate(item.pairing_details.submission_date)))]), _vm._v(" "), _c('td', {
            staticStyle: {
              "min-width": "12rem"
            }
          }, [_c('div', [(item.payout_details && item.payout_details.status !== _vm.payoutStatus.CONFIRMED && !_vm.isAM) ? _c('v-btn', {
            staticClass: "mb-1",
            attrs: {
              "color": "primary",
              "small": ""
            },
            on: {
              "click": function($event) {
                return _vm.updateSend(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": "",
              "left": ""
            }
          }, [_vm._v("new_releases")]), _vm._v(" Confirm Payout\n                  ")], 1) : _vm._e(), _vm._v(" "), (item.payout_details && item.payout_details.status === _vm.payoutStatus.CONFIRMED) ? _c('v-chip', {
            attrs: {
              "color": "green",
              "outlined": "",
              "small": ""
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": "",
              "left": ""
            }
          }, _vm.on), [_vm._v("done")]), _vm._v("Confirmed\n                  ")], 1) : _vm._e(), _vm._v(" "), (item.payout_details && item.payout_details.status === _vm.payoutStatus.CONFIRMED && !_vm.isAM) ? _c('v-btn', {
            attrs: {
              "text": "",
              "small": "",
              "color": "error",
              "disabled": _vm.disableLockedCOGS
            },
            on: {
              "click": function($event) {
                return _vm.cancelPayout(item)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "x-small": "",
              "data-toggle": "tooltip",
              "data-placement": "button",
              "title": "Click to cancel Payout"
            }
          }, [_vm._v("mdi-cancel")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('td', [_c('div', [(!item.inReport) ? _c('v-chip', {
            attrs: {
              "color": "error",
              "outlined": "",
              "small": "",
              "to": ('/campaign-report-internal?id=' + _vm.campaignID),
              "target": "_blank",
              "data-toggle": "tooltip",
              "data-placement": "top",
              "title": "Click to add contents to Report"
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": "",
              "left": ""
            }
          }, _vm.on), [_vm._v("warning")]), _vm._v(" Pending in Report\n                  ")], 1) : _vm._e(), _vm._v(" "), (item.inReport) ? _c('v-chip', {
            attrs: {
              "color": "green",
              "outlined": "",
              "small": "",
              "to": ('/campaign-report-internal?id=' + _vm.campaignID),
              "target": "_blank"
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": "",
              "left": ""
            }
          }, _vm.on), [_vm._v("done")]), _vm._v(" Present in Report\n                  ")], 1) : _vm._e()], 1)]), _vm._v(" "), _c('td', _vm._l((item.paymentStatusDisplay), function(p, index) {
            return _c('div', {
              key: index,
              staticClass: "payment-status-list"
            }, [((p !== null && p.statusDisplay)) ? _c('v-chip', {
              staticClass: "payment-status-chip",
              class: ("payment-status-chip--" + (p.statusDisplay.value)),
              style: ({
                borderColor: p.statusDisplay.color || 'var(--ims-color-secondary)'
              }),
              attrs: {
                "outlined": "",
                "small": "",
                "to": ('/finance/payment-consolidation'),
                "target": "_blank"
              }
            }, [(p.imported) ? _c('v-tooltip', {
              attrs: {
                "bottom": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function(ref) {
                  var on = ref.on;

                  return [_c('span', _vm._g({
                    staticClass: "payment-status-imported-badge",
                    attrs: {
                      "aria-label": "Imported payment"
                    }
                  }, on), [_c('v-icon', {
                    staticClass: "payment-status-icon",
                    attrs: {
                      "small": ""
                    }
                  }, [_vm._v("mdi-newspaper-plus")])], 1)]
                }
              }], null, true)
            }, [_vm._v(" "), _c('span', [_vm._v("Imported payment")])]) : _vm._e(), _vm._v(" "), _c('span', {
              staticClass: "payment-status-label",
              style: ({
                color: p.statusDisplay.color || 'var(--ims-color-secondary)'
              })
            }, [_vm._v("\n                      " + _vm._s(p.statusDisplay.text) + "\n                    ")]), _vm._v(" "), _c('span', {
              staticClass: "payment-status-divider",
              attrs: {
                "aria-hidden": "true"
              }
            }), _vm._v(" "), (p.payConsAmt) ? _c('v-tooltip', {
              attrs: {
                "bottom": ""
              },
              scopedSlots: _vm._u([{
                key: "activator",
                fn: function(ref) {
                  var on = ref.on;

                  return [_c('span', _vm._g({
                    staticClass: "payment-status-amount"
                  }, on), [_vm._v("\n                          " + _vm._s(_vm.utilsFunc.currencySym(p.currency)) + " " + _vm._s(_vm._f("thousandSeprator")(p.payConsAmt)) + "\n                        ")])]
                }
              }], null, true)
            }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(p.currency) + " " + _vm._s(_vm._f("thousandSeprator")(p.payConsAmt)))]), _c('br'), _vm._v(" "), (p.sgdAmt) ? _c('span', [_vm._v("Estimated SGD: " + _vm._s(p.sgdAmt && !Number.isNaN(Number(p.sgdAmt)) ? p.sgdAmt : ""))]) : _vm._e()]) : _vm._e()], 1) : _vm._e()], 1)
          }), 0)])
        })], 2)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('influencer-detail-modal', {
    attrs: {
      "dialog": _vm.dialog,
      "influencer": _vm.influencer,
      "influencerProfile": _vm.influencerProfile,
      "selectedTab": _vm.selectedTab,
      "briefDetailContent": _vm.briefDetailsHTML,
      "close": _vm.closeModal,
      "newPairingFlow": true,
      "isDownload": _vm.invoiceDownload
    },
    on: {
      "loadInfluencer": _vm.loadInfluencerData,
      "reRenderDatTable": _vm.loadInfluencerData,
      "loadingDialogOpen": _vm.loadingDialogOpen,
      "loadingDialogClose": _vm.loadingDialogClose
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-card-text', {
    staticClass: "loading-dialog-text"
  }, [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "secondary"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd2e3964"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/PaymentConsolidationStatus.vue
// module id = 2282
// module chunks = 0